require('../modules/es6.symbol');

require('../modules/es6.object.create');

require('../modules/es6.object.define-property');

require('../modules/es6.object.define-properties');

require('../modules/es6.object.get-own-property-descriptor');

require('../modules/es6.object.get-prototype-of');

require('../modules/es6.object.keys');

require('../modules/es6.object.get-own-property-names');

require('../modules/es6.object.freeze');

require('../modules/es6.object.seal');

require('../modules/es6.object.prevent-extensions');

require('../modules/es6.object.is-frozen');

require('../modules/es6.object.is-sealed');

require('../modules/es6.object.is-extensible');

require('../modules/es6.object.assign');

require('../modules/es6.object.is');

require('../modules/es6.object.set-prototype-of');

require('../modules/es6.object.to-string');

require('../modules/es6.function.bind');

require('../modules/es6.function.name');

require('../modules/es6.function.has-instance');

require('../modules/es6.parse-int');

require('../modules/es6.parse-float');

require('../modules/es6.number.constructor');

require('../modules/es6.number.to-fixed');

require('../modules/es6.number.to-precision');

require('../modules/es6.number.epsilon');

require('../modules/es6.number.is-finite');

require('../modules/es6.number.is-integer');

require('../modules/es6.number.is-nan');

require('../modules/es6.number.is-safe-integer');

require('../modules/es6.number.max-safe-integer');

require('../modules/es6.number.min-safe-integer');

require('../modules/es6.number.parse-float');

require('../modules/es6.number.parse-int');

require('../modules/es6.math.acosh');

require('../modules/es6.math.asinh');

require('../modules/es6.math.atanh');

require('../modules/es6.math.cbrt');

require('../modules/es6.math.clz32');

require('../modules/es6.math.cosh');

require('../modules/es6.math.expm1');

require('../modules/es6.math.fround');

require('../modules/es6.math.hypot');

require('../modules/es6.math.imul');

require('../modules/es6.math.log10');

require('../modules/es6.math.log1p');

require('../modules/es6.math.log2');

require('../modules/es6.math.sign');

require('../modules/es6.math.sinh');

require('../modules/es6.math.tanh');

require('../modules/es6.math.trunc');

require('../modules/es6.string.from-code-point');

require('../modules/es6.string.raw');

require('../modules/es6.string.trim');

require('../modules/es6.string.iterator');

require('../modules/es6.string.code-point-at');

require('../modules/es6.string.ends-with');

require('../modules/es6.string.includes');

require('../modules/es6.string.repeat');

require('../modules/es6.string.starts-with');

require('../modules/es6.string.anchor');

require('../modules/es6.string.big');

require('../modules/es6.string.blink');

require('../modules/es6.string.bold');

require('../modules/es6.string.fixed');

require('../modules/es6.string.fontcolor');

require('../modules/es6.string.fontsize');

require('../modules/es6.string.italics');

require('../modules/es6.string.link');

require('../modules/es6.string.small');

require('../modules/es6.string.strike');

require('../modules/es6.string.sub');

require('../modules/es6.string.sup');

require('../modules/es6.date.now');

require('../modules/es6.date.to-json');

require('../modules/es6.date.to-iso-string');

require('../modules/es6.date.to-string');

require('../modules/es6.date.to-primitive');

require('../modules/es6.array.is-array');

require('../modules/es6.array.from');

require('../modules/es6.array.of');

require('../modules/es6.array.join');

require('../modules/es6.array.slice');

require('../modules/es6.array.sort');

require('../modules/es6.array.for-each');

require('../modules/es6.array.map');

require('../modules/es6.array.filter');

require('../modules/es6.array.some');

require('../modules/es6.array.every');

require('../modules/es6.array.reduce');

require('../modules/es6.array.reduce-right');

require('../modules/es6.array.index-of');

require('../modules/es6.array.last-index-of');

require('../modules/es6.array.copy-within');

require('../modules/es6.array.fill');

require('../modules/es6.array.find');

require('../modules/es6.array.find-index');

require('../modules/es6.array.species');

require('../modules/es6.array.iterator');

require('../modules/es6.regexp.constructor');

require('../modules/es6.regexp.exec');

require('../modules/es6.regexp.to-string');

require('../modules/es6.regexp.flags');

require('../modules/es6.regexp.match');

require('../modules/es6.regexp.replace');

require('../modules/es6.regexp.search');

require('../modules/es6.regexp.split');

require('../modules/es6.promise');

require('../modules/es6.map');

require('../modules/es6.set');

require('../modules/es6.weak-map');

require('../modules/es6.weak-set');

require('../modules/es6.typed.array-buffer');

require('../modules/es6.typed.data-view');

require('../modules/es6.typed.int8-array');

require('../modules/es6.typed.uint8-array');

require('../modules/es6.typed.uint8-clamped-array');

require('../modules/es6.typed.int16-array');

require('../modules/es6.typed.uint16-array');

require('../modules/es6.typed.int32-array');

require('../modules/es6.typed.uint32-array');

require('../modules/es6.typed.float32-array');

require('../modules/es6.typed.float64-array');

require('../modules/es6.reflect.apply');

require('../modules/es6.reflect.construct');

require('../modules/es6.reflect.define-property');

require('../modules/es6.reflect.delete-property');

require('../modules/es6.reflect.enumerate');

require('../modules/es6.reflect.get');

require('../modules/es6.reflect.get-own-property-descriptor');

require('../modules/es6.reflect.get-prototype-of');

require('../modules/es6.reflect.has');

require('../modules/es6.reflect.is-extensible');

require('../modules/es6.reflect.own-keys');

require('../modules/es6.reflect.prevent-extensions');

require('../modules/es6.reflect.set');

require('../modules/es6.reflect.set-prototype-of');

module.exports = require('../modules/_core');
void function register() {
  /* react-hot-loader/webpack */
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }
  /* eslint-disable camelcase, no-undef */


  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports;
  /* eslint-enable camelcase, no-undef */

  if (!webpackExports) {
    return;
  }

  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/core-js/es6/index.js");
    return;
  }
  /* eslint-disable no-restricted-syntax */


  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */
    if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }

    var namedExport = void 0;

    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }

    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/core-js/es6/index.js");
  }
}();